import { useMemo } from 'react'

import { useWindow } from '@krp/client-runtime'
import {
  PLATFORM_WINDOWS,
  SourceAddScreen,
  makeSelectSourceAddVm,
  type SourceAddActions,
} from '@krp/platform-ui'

import { CONNECTION_FORMS } from '../../composition/connectionForms'
import { useConnectors } from './useConnectors'
import { useMyAccess } from './useMyAccess'

/**
 * Binding окна «Добавить источник» (шаг 1 — плитки видов). Выбранная плитка заменяет это окно формой «Новый источник»
 * этого вида в том же месте стопки окон: один модальный поток «плитки → форма → готово», без второго окна поверх.
 */
export function SourceAddBinding() {
  const window = useWindow()
  const access = useMyAccess()
  const connectors = useConnectors()
  const selectVm = useMemo(() => makeSelectSourceAddVm(), [])
  const vm = selectVm({ access, connectors: connectors.query, forms: CONNECTION_FORMS })
  const refetchConnectors = connectors.refetch

  const actions = useMemo<SourceAddActions>(
    () => ({
      pick: (kind) => window.replaceWith(PLATFORM_WINDOWS.resourceAdd, { kind }),
      reload: () => void refetchConnectors(),
      cancel: window.close,
    }),
    [refetchConnectors, window],
  )

  return <SourceAddScreen vm={vm} actions={actions} />
}
